/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_Paused_BodyInputs */

const en_us2_workout_live_paused_body = /** @type {(inputs: Workout_Live_Paused_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paused time doesn't count toward the workout's duration.`)
};

const pt_br2_workout_live_paused_body = /** @type {(inputs: Workout_Live_Paused_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O tempo pausado não conta na duração do treino.`)
};

const es_419_workout_live_paused_body = /** @type {(inputs: Workout_Live_Paused_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El tiempo en pausa no cuenta en la duración del entrenamiento.`)
};

const pt_pt2_workout_live_paused_body = /** @type {(inputs: Workout_Live_Paused_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O tempo em pausa não conta para a duração do treino.`)
};

const fr_fr2_workout_live_paused_body = /** @type {(inputs: Workout_Live_Paused_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le temps de pause ne compte pas dans la durée de la séance.`)
};

const de_de2_workout_live_paused_body = /** @type {(inputs: Workout_Live_Paused_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausierte Zeit zählt nicht zur Trainingsdauer.`)
};

const it_it2_workout_live_paused_body = /** @type {(inputs: Workout_Live_Paused_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tempo in pausa non conta nella durata dell'allenamento.`)
};

/**
* | output |
* | --- |
* | "Paused time doesn't count toward the workout's duration." |
*
* @param {Workout_Live_Paused_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_paused_body = /** @type {((inputs?: Workout_Live_Paused_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Paused_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_paused_body(inputs)
	if (locale === "es-419") return es_419_workout_live_paused_body(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_paused_body(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_paused_body(inputs)
	if (locale === "de-DE") return de_de2_workout_live_paused_body(inputs)
	if (locale === "it-IT") return it_it2_workout_live_paused_body(inputs)
	return en_us2_workout_live_paused_body(inputs)
});
export { workout_live_paused_body as "workout-live.paused_body" }